import Schema from 'AppReact/schema';
import { personToMention, commentActions } from 'types';

export default {
  localUrls: Schema('string', 'primitive-nullable', { defaultValue: [] }),
  content_types: Schema('string', 'array', { defaultValue: [] }),
  uuids: Schema('string', 'primitive-nullable', { defaultValue: [] }),
  inputVal: Schema('string', 'primitive', { defaultValue: '' }),
  personsToMention: Schema(personToMention, 'array', { defaultValue: [] }),
  mentioned: Schema('integer', 'array', { defaultValue: [] }),
  hasPrivacy: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  isEditing: Schema('boolean', 'primitive', { defaultValue: false }),
  privacy: Schema('string', 'primitive', { defaultValue: 'Public' }),
  acceptDocuments: Schema('string', 'primitive', { defaultValue: false }),
  placeholder: Schema('string', 'primitive-nullable', { defaultValue: null }),
  displayBottom: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  redBorder: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
}
